import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Icon, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { IndicesCadastro } from "../../indices/IndicesCadastro";
import { ITipo_Indice_Documento } from "../../../services/api/tipo_indice/Tipo_Indice_Service";

export interface IMigracaoSugeridaProps {
    /**
     * Função ao confirmar
     * */
    AoConfirmar: () => void;
    /**
     * Função ao cancelar
     * */
    AoCancelar: () => void;
    abrir: boolean;
    isLoading: boolean;
    rowsIndiceOrigem: ITipo_Indice_Documento[];
    rowsIndiceDestino: ITipo_Indice_Documento[];
    valoresOrigem: string[];
    valoresDestino: string[];
    onValoresDestinoChange: (valores: string[]) => void;
}

export const MigracaoSugerida: React.FC<IMigracaoSugeridaProps> = ({
    AoConfirmar,
    AoCancelar,
    abrir,
    isLoading,
    rowsIndiceOrigem,
    rowsIndiceDestino,
    valoresOrigem,
    valoresDestino,
    onValoresDestinoChange,
}) => {
    const [abrirModal, setAbrirModal] = useState<boolean>(false);

    useEffect(() => { setAbrirModal(abrir) }, [abrir]);

    return (
        <Dialog
            open={abrirModal}
            onClose={() => AoCancelar()}
            fullWidth
            maxWidth="lg"
        >
            <DialogTitle id="scroll-dialog-title"> Migração Sugerida </DialogTitle>
            <DialogContent dividers>
                {isLoading ? (
                    <Box display="flex" justifyContent="center" alignItems="center">
                        <CircularProgress />
                    </Box>
                ) : (
                    <Box display="flex" flexDirection="row" gap={2}>
                        <Paper>
                            <Box padding={2}>

                                <Typography variant="h6" gutterBottom>
                                    Índices atuais do documento:
                                </Typography>

                                <IndicesCadastro
                                    aoSalvar={() => 0}
                                    rowsAlterarValorIndice={rowsIndiceOrigem}
                                    onValoresAlterarChange={() => undefined}
                                    reset={false}
                                    initialValues={valoresOrigem}
                                    somenteLeitura
                                />
                            </Box>
                        </Paper>
                        <Paper>
                            <Box padding={2}>

                                <Typography variant="h6" gutterBottom>
                                    Índices do documento no novo tipo:
                                </Typography>

                                <IndicesCadastro
                                    aoSalvar={AoConfirmar}
                                    rowsAlterarValorIndice={rowsIndiceDestino}
                                    onValoresAlterarChange={onValoresDestinoChange}
                                    reset={false}
                                    initialValues={valoresDestino}
                                />
                            </Box>
                        </Paper>
                    </Box>
                )}

            </DialogContent>
            <DialogActions>
                <Box
                    width="100%"
                    marginX={1}
                    padding={1}
                    paddingX={2}
                    gap={1}
                    display="flex"
                    justifyContent="center"
                >
                    <Button variant="contained" color="error" startIcon={<Icon>close</Icon>} onClick={() => AoCancelar()}>
                        <Typography variant='button' noWrap> Fechar </Typography>
                    </Button>

                    <Button variant="contained" startIcon={<Icon>check</Icon>} onClick={AoConfirmar} disabled={isLoading}>
                        <Typography variant='button' noWrap> Confirmar </Typography>
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
}